import * as React from 'react';

import { WhiteLabel } from 'pages/partners/site_branding/interfaces';
import { Editor, EditorTools } from '@progress/kendo-react-editor';

export const RichTextEditor: React.FC<{
    content: string;
    selectedWhiteLabelObj: WhiteLabel;
    setContent: (content: WhiteLabel) => void;
    value: string | null;
}> = ({ content, selectedWhiteLabelObj, setContent, value }) => {

    const emptyTestObj = <div></div>;
    const {
        AlignCenter,
        AlignLeft,
        AlignRight,
        Bold,
        Indent,
        Italic,
        Link,
        OrderedList,
        Outdent,
        Redo,
        Underline,
        Undo,
        Unlink,
        UnorderedList,
        ViewHtml
    } = EditorTools;

    return (
        <>
            <Editor
                contentStyle={{
                    height: 270
                }}
                tools={[
                    [Bold, Italic, Underline],
                    [Undo, Redo],
                    [Link, Unlink],
                    [AlignLeft, AlignCenter, AlignRight],
                    [OrderedList, UnorderedList, ViewHtml]
                ]}
                onChange={e => content === 'supportString' ? setContent({ ...selectedWhiteLabelObj, SupportString: e.html }) : setContent({ ...selectedWhiteLabelObj, Policy: e.html })}
                value={value !== null ? value : ''}
            />
            { emptyTestObj }
        </>
    );

};
